import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/app/providers/AuthProvider";
import { LoadingSpinner } from "@/shared/components/LoadingSpinner";
import { getAddressValidationCapabilities } from "@/shared/utils/roles";

export function AddressValidationSectionOutlet() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingSpinner fullScreen />;
  }

  if (!getAddressValidationCapabilities(user?.role).canAccess) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
